<span class="cumulative-cost" [matTooltip]="costTooltip">
  {{ cumulativeCost }}
</span>
